import styled from 'styled-components';

export const Container = styled.div`
  header {
    display: flex;
    justify-content: space-between;
  }
`;

export const TitleLockedIcon = styled.div``;

export const ButtonLock = styled.div`
  display: flex;
  align-items: center;
`;

export const ContainerSpinner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-right: 10rem;
  min-height: 90vh;
`;

export const CheckIntegrate = styled.div`
  margin-top: 30px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  #labelIsLocked {
    margin-left: 6px;
  }
`;

export const SummaryContainer = styled.div`
  margin-top: 10px;
`;

export const SummarySaveButtonWrapper = styled.div`
  margin-bottom: 10px;
`;

export const SummaryRowsContainer = styled.div`
  margin-top: 20px;
`;

export const SummaryRow = styled.div<{ $isDragging?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  opacity: ${({ $isDragging }) => ($isDragging ? 0.4 : 1)};
`;

export const SummaryDragHandle = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  color: #888;
  padding: 4px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'grab')};
`;

export const SummaryGroupDivider = styled.div`
  border-top: 1px dashed #ccc;
  margin: 4px 0 16px;
`;

export const SummaryQuestionField = styled.div`
  flex: 2;
`;

export const SummaryTypeField = styled.div`
  flex: 1;
`;

export const SummaryCustomTextInput = styled.input`
  flex: 2;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 38px;
  box-sizing: border-box;

  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const SummaryRemoveButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: #c53030;
  padding: 4px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const SummaryAddButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px dashed #888;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  margin-top: 4px;

  &:hover {
    background: #f5f5f5;
  }
`;
